import * as Constants from '../constants';

export default {
	toggleMySupplier(supplierId) {

		return fetch(Constants.ENVIRONMENT_API + `products/updateMySuppliers`, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'AuthenticatedUser': window.LMC.authenticatedUser
			},
			body: JSON.stringify(supplierId)
		})
		.then(response => {
			if (response.ok) {
				return Promise.resolve(response);
			}
			else {
				return Promise.reject(new Error(error));
			}
		})
	}
};